import * as types from '../../actions/actionsTypes/loadingOverlayActionTypes';

export const initialStateLoadingOverlay = {
    isActive: false,
    text: 'Caricamento dati in corso....',
    count: 0
};

export const loadingOverlayReducer = (loadingOverlays = initialStateLoadingOverlay, action) => {
    if (!action || !action.type) return loadingOverlays;

    switch (action.type) {
        case types.SHOW_LOADING_OVERLAY:
            return {
                ...loadingOverlays,
                isActive: action.payload.isActive,
                count: loadingOverlays.count + 1
            };
        case types.HIDE_LOADING_OVERLAY:
            if ((loadingOverlays.count - 1) === 0) {
                return {
                    ...loadingOverlays,
                    isActive: action.payload.isActive,
                    count: loadingOverlays.count - 1
                }
            } else if ((loadingOverlays.count - 1) > 0) {
                return {
                    ...loadingOverlays,
                    isActive: true,
                    count: loadingOverlays.count - 1
                }
            } else if ((loadingOverlays.count - 1) < 0) {
                return {
                    ...loadingOverlays,
                    isActive: action.payload.isActive,
                    count: 0
                }
            }
            break;

        default:
            return loadingOverlays;
    }
};
